export const isRectOutside = (rect: DOMRect, containerRect: DOMRect) => {
    return (
        rect.right > containerRect.right || // extends beyond right edge
        rect.bottom > containerRect.bottom || // extends beyond bottom edge
        rect.left < containerRect.left || // extends beyond left edge
        rect.top < containerRect.top // extends beyond top edge
    );
};
